module.exports = __webpack_public_path__ + "img/chart-doc-icon.152983a8.svg";